import { createSlice, isAnyOf, Reducer } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash-es';
import {
  changeFilter,
  changePage,
  changeSort,
  clearFilters,
  createCusat,
  deleteCusat,
  exportCusat,
  getCusatList,
  importCusat,
  updateCusat,
} from './actions';
import { cusatInitialState, initialFilters, storeName } from './config';
import addCommonCases from '../addCommonCases';

export * from './interfaces';
export * from './actions';
export * from './selectors';

const cusat = createSlice({
  name: storeName,
  initialState: cloneDeep(cusatInitialState),
  reducers: {},
  extraReducers: (builder) => {
    addCommonCases(builder, cusatInitialState)
      .addCase(getCusatList.fulfilled, (state, { payload }) => {
        state.items = payload.list;
        state.pagination = payload.pagination;
        state.init = true;
      })
      .addCase(changeFilter, (state, { payload: { key, value } }) => {
        Object.assign(state.filters, { [key]: value });
        state.pagination.page = 1;
      })
      .addCase(clearFilters, (state) => {
        Object.assign(state.filters, initialFilters);
        state.pagination.page = 1;
      })
      .addCase(changePage, (state, { payload }) => {
        state.pagination.page = payload;
      })
      .addCase(changeSort, (state, { payload }) => {
        if (state.sort.sortBy === payload) {
          state.sort.sortOrder =
            state.sort.sortOrder === 'ASC' ? 'DESC' : 'ASC';
        } else {
          state.sort.sortBy = payload;
          state.sort.sortOrder = 'ASC';
        }
        state.pagination.page = 1;
      });

    builder.addMatcher(isAnyOf(getCusatList.pending), (state) => {
      state.loading = true;
    });
    builder.addMatcher(
      isAnyOf(getCusatList.fulfilled, getCusatList.rejected),
      (state) => {
        state.loading = false;
      },
    );

    builder.addMatcher(
      isAnyOf(createCusat.pending, updateCusat.pending, deleteCusat.pending),
      (state) => {
        state.updating = true;
      },
    );
    builder.addMatcher(
      isAnyOf(
        createCusat.fulfilled,
        createCusat.rejected,
        updateCusat.fulfilled,
        updateCusat.rejected,
        deleteCusat.fulfilled,
        deleteCusat.rejected,
      ),
      (state) => {
        state.updating = false;
      },
    );

    builder.addMatcher(isAnyOf(exportCusat.pending), (state) => {
      state.exporting = true;
    });
    builder.addMatcher(
      isAnyOf(exportCusat.fulfilled, exportCusat.rejected),
      (state) => {
        state.exporting = false;
      },
    );

    builder.addMatcher(isAnyOf(importCusat.pending), (state) => {
      state.importing = true;
    });
    builder.addMatcher(
      isAnyOf(importCusat.fulfilled, importCusat.rejected),
      (state) => {
        state.importing = false;
      },
    );
  },
});

export default cusat.reducer as Reducer<typeof cusatInitialState>;
